import React from 'react';
import { Route } from 'react-router-dom';
import { RedirectRoute } from './components/RedirectRoute';
import Lander from './pages/Lander';
import Onboarding from './pages/Onboarding';

export const OnboardingRoutes = [
    <Route key="welcome" path="/welcome" element={<Lander />} />,
    <Route key="onboarding" path="/onboarding" element={<Onboarding />} />,
    <Route
        key="onboarding-button"
        path="/onboarding-button"
        element={<RedirectRoute pathname="/onboarding" />}
    />,
];
